<h3>Following example shows a sidebar page layout with a collapsable sidebar container that can hold different navigation entries.</h3>
<div>
  <h3>Design Guidelines</h3>
  <p>All pages in an application should follow a common layout structure to ensure a consistent user experience across applications.</p>
  <p>The Base SidebarLayout includes the following components:</p>
  <ul>
    <li>Same components as the base page layout</li>
    <li>plus a collapsable navigation panel on the right hand side</li>
    <li>
      the default text color used for the links is #900 from the primary-palette of the theme. As an alternative you can define your own
      '--palette-color' variable
    </li>
  </ul>
</div>

<h3>Demo</h3>
<mad-primary-button routerLink="/full-page-layouts/sidebar-page-layout">Open Sidebar Pagelayout Demo</mad-primary-button><br />
<app-code-snippet [code]="sidebarPageLayout"></app-code-snippet>
<br />
<h3>
  The Advanced Sidebar Layout With Custom Header (mad-sidebar-layout) integrates a flexible integration system with customizable header,
  sidebar, content and footer sections.
</h3>
<div>
  <h3>Design Guidelines</h3>
  <p>The Advanced Sidebar Layout With Custom Header works with Angular Portals and includes the following components:</p>
  <ul>
    <li>headerContent - Customizable header content</li>
    <li>sideBarItems - Navigation items for the sidebar</li>
    <li>content - Main content area where router components are displayed</li>
    <li>footer - Footer area</li>
  </ul>
</div>

<h3>Demo</h3>
<mad-primary-button routerLink="/full-page-layouts/advanced-sidebar-page-layout">Open Advanced Sidebar Pagelayout Demo</mad-primary-button
><br />
<app-code-snippet [code]="advancedSidebarLayout"></app-code-snippet>
<br />

<h3>
  The Advanced Sidebar Layout With Default Header (mad-sidebar-layout) offers a variation of the sidebar layout that includes a default
  header with an additional action group.
</h3>
<div>
  <h3>Design Guidelines</h3>
  <p>The Advanced Sidebar Layout With Default Header works with Angular Portals and includes the following components:</p>
  <ul>
    <li>actionGroup - Default header action buttons content</li>
    <li>title - Default header title</li>
    <li>hasBackButton - Default header back button appearance</li>
    <li>content - Main content area where router components are displayed</li>
    <li>footer - Footer area</li>
  </ul>
</div>

<h3>Demo</h3>
<mad-primary-button routerLink="/full-page-layouts/advanced-sidebar-with-default-header-page-layout"
  >Open Advanced Sidebar Pagelayout With Default Header Demo</mad-primary-button
><br />
<app-code-snippet [code]="advancedSidebarWithDefaultHeaderLayout"></app-code-snippet>
